import { OtpView, ResetPassword } from "Common/Components";
import { useResetPassword } from "../../hooks";

interface ResetPasswordViewProps {}

export const ResetPasswordView: React.FC<ResetPasswordViewProps> = () => {
  const { formik, formikOtp, steepValue, resendOtp } = useResetPassword();

  return (
    <div>
      {steepValue === 1 ? (
        <ResetPassword formik={formik} />
      ) : (
        <OtpView formik={formikOtp} resendOtp={resendOtp} />
      )}
    </div>
  );
};
